import React from "react";
import './IongChart2.scss';
import {
  Radar,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Legend,
  ResponsiveContainer
} from 'recharts';

const IongChart2 = ({ data = [], studentKey = "student", parentKey = "parent", maxRadius = 11 }) => {
  // 실제 데이터가 있는지 여부 체크
  const hasStudent = data.some(d => typeof d[studentKey] === 'number');
  const hasParent = data.some(d => typeof d[parentKey] === 'number');

  return (

    <div className="IongChart2">
      
    <div className="custom-radar-chart">

      <ResponsiveContainer width="100%" height="100%">
        
        <RadarChart
          cx="50%"
          cy="50%"
          outerRadius="80%"
          data={data}
        >
          {/* 눈금선 */}
          <PolarGrid />

          {/* 축 */}
          <PolarRadiusAxis domain={[0, maxRadius]} />
          <PolarAngleAxis dataKey="subject" />

          {/* 조건부로 각각 그리기 */}
          

          {hasParent && (
            <Radar
              name="학부모"
              dataKey={parentKey}
              stroke="green"
              fill="green"
              fillOpacity={0.3}
            />
          )}

          {hasStudent && (
            <Radar
              name="학생"
              dataKey={studentKey}
              stroke="red"
              fill="red"
              fillOpacity={0.5}
            />
          )}

          {(hasStudent || hasParent) && <Legend />}
        </RadarChart>
      </ResponsiveContainer>
  

    </div>

 

    </div>

  );
};

export default IongChart2;
